export const barcodePattern = /^\d{8,32}$/;
